import * as tslib_1 from "tslib";
import { BaseModule } from '../base/Module';
import { FlagSimpleXdmDefinitionBuilder } from './FlagSimpleXdmDefinitionBuilder';
export var FlagModuleDefinitions;
(function (FlagModuleDefinitions) {
    FlagModuleDefinitions.FLAG_MODULE_NAME = 'flag';
    var Props = /** @class */ (function () {
        function Props(adaptor, flagProvider) {
            this.adaptor = adaptor;
            this.flagProvider = flagProvider;
        }
        return Props;
    }());
    FlagModuleDefinitions.Props = Props;
    var State = /** @class */ (function () {
        function State(flagProvider) {
            this.enabled = true;
            this.registered = false;
            this.flagProvider = flagProvider;
            this.simpleXdmDefinitionBuilder = new FlagSimpleXdmDefinitionBuilder(flagProvider);
        }
        return State;
    }());
    FlagModuleDefinitions.State = State;
})(FlagModuleDefinitions || (FlagModuleDefinitions = {}));
/**
 * This module provides flag related functionality.
 */
var FlagModule = /** @class */ (function (_super) {
    tslib_1.__extends(FlagModule, _super);
    function FlagModule(props) {
        return _super.call(this, props) || this;
    }
    FlagModule.prototype.componentWillMount = function () {
        if (!this.props.flagProvider) {
            throw new Error('this.props.flagProvider is not defined');
        }
        this.setState(new FlagModuleDefinitions.State(this.props.flagProvider));
    };
    FlagModule.prototype.getModuleRegistrationName = function () {
        return FlagModuleDefinitions.FLAG_MODULE_NAME;
    };
    FlagModule.prototype.getSimpleXdmDefinitionBuilder = function () {
        return this.state.simpleXdmDefinitionBuilder;
    };
    FlagModule.prototype.getProvider = function () {
        return this.props.flagProvider;
    };
    FlagModule.prototype.render = function () {
        return null;
    };
    return FlagModule;
}(BaseModule));
export { FlagModule };
//# sourceMappingURL=FlagModule.js.map